import { render, staticRenderFns } from "./VisitDetailFormComponent.vue?vue&type=template&id=19af8663&scoped=true"
import script from "./VisitDetailFormComponent.vue?vue&type=script&lang=ts"
export * from "./VisitDetailFormComponent.vue?vue&type=script&lang=ts"
import style0 from "./VisitDetailFormComponent.vue?vue&type=style&index=0&id=19af8663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19af8663",
  null
  
)

export default component.exports